import classNames from 'classnames';
import { CloseIcon } from '../../assets/icons';
import Button from '../../components/Button/Button';
import Toast from '../../components/Toast/Toast';
import Justify from '../../types/enum/Justify';
import Position from '../../types/enum/Position';
import Theme from '../../types/enum/Theme';
import Icon from '../Icon/Icon';
import './Snackbar.scss';
import ISnackbarProps from './SnackbarProps';

const Snackbar = ({
  isOpen = false,
  onClose,
  timeout = 0,
  canDismiss = true,
  justify = Justify.FLEX_START,
  theme = Theme.DARK,
  size = 'basic',
  position = Position.BOTTOM,
  speedIn = 500,
  speedOut = 250,
  className,
  children,
}: ISnackbarProps) => {
  const classes = classNames(
    'snackbar',
    {
      [`snackbar-position-${position}`]: true,
      [`snackbar-${size}`]: true,
    },
    className
  );

  return (
    <Toast
      className={classes}
      justify={justify}
      isOpen={isOpen}
      onClose={onClose}
      speedIn={speedIn}
      speedOut={speedOut}
      theme={theme}
      timeout={timeout}
      position={position}
    >
      {children}
      {canDismiss && (
        <div className="snackbar-dismiss">
          <Button type="icon" theme={theme === Theme.LIGHT ? Theme.LIGHT : Theme.DARK} onClick={onClose}>
            <Icon svg={CloseIcon} />
          </Button>
        </div>
      )}
    </Toast>
  );
};

export default Snackbar;
